import React from 'react';

// Render text nodes, never HTML. Support WhatsApp *bold* and **bold**.
/** Purpose: render bot-authored message text with supported formatting. Why: chat transcripts need safe, consistent rendering of markdown-like content. */
export default function BotMessageText({ text }) {
  return String(text ?? '').split(/(\*\*[^*\n]+\*\*|\*[^*\n]+\*)/g).map((part, index) => {
    const match = /^(\*\*|\*)(\S(?:[^*\n]*\S)?)\1$/.exec(part);
    return match ? <strong key={index}>{match[2]}</strong> : part;
  });
}
